import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OidcLoginContextService } from '@core/auth/oidc-login-context.service';

export const queryGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const oidcLoginContext = inject(OidcLoginContextService);
  const { code, state } = route.queryParams;
  if (code && state) {
    return true;
  }
  router.navigate([oidcLoginContext.getPendingConfigIdPath()]);
  return false;
};
